import { Key } from "react";

import ROUTES from "manager/config/routes";
import { transformRoute } from "shared/utils/routing";

const SCROLL_DEADLINE_MS = 2000;

const TAB_CONTENT_SELECTOR = [
  '[data-testid="deal-review-tab"]',
  '[data-testid="deal-review-leasing"]',
  '[data-testid="deal-review-empty"]',
].join(", ");

/**
 * Every banner affordance that opens the deal review tab routes through here:
 * select the tab, then bring its content into view once it mounts — the tab
 * sits below the banner, so a bare route push selects it out of sight.
 */
export const categoryAnchorId = (category: string) =>
  `deal-review-category-${category.toLowerCase()}`;

export const openDealReview = (
  history: { push: (path: string) => void },
  dealId: Key,
  category?: string | null
) => {
  history.push(transformRoute(ROUTES.dealReview, { id: dealId }));
  const started = Date.now();
  const tryScroll = () => {
    const anchored = category
      ? document.getElementById(categoryAnchorId(category))
      : null;
    const el = anchored ?? document.querySelector(TAB_CONTENT_SELECTOR);
    const expired = Date.now() - started >= SCROLL_DEADLINE_MS;
    // sections flag data-settling while their reads are in flight; scrolling
    // early anchors against a half-mounted layout that the late rows then
    // shove downward. Past the deadline scroll anyway — top-aligned, which
    // stays put however much content grows below it.
    const settling = document.querySelector("[data-settling]");
    if (el && (!settling || expired)) {
      const fits =
        !anchored &&
        !settling &&
        el.getBoundingClientRect().height < window.innerHeight * 0.8;
      el.scrollIntoView({
        behavior: "smooth",
        block: fits ? "center" : "start",
      });
      return;
    }
    if (!expired) {
      window.requestAnimationFrame(tryScroll);
    }
  };
  window.requestAnimationFrame(tryScroll);
};
